import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

// Écran chargé à la demande : le portail client et la connexion n'en téléchargent pas le code.
const ParkScreen = lazy(() => import('../screens/ParkScreen.js'));

/** « À l'atelier » (ex-Parc) : véhicules actuellement présents au garage, route `/parc` gardée. */
export default function ParkPage() {
  return (
    <GarageGate>
      <ParkScreen />
    </GarageGate>
  );
}
